//请自行添加语言资源
const planAppointmentLog = {
  serialNo: '流水号',
  outPlanNo: '运输计划单号(外部)',
  planNo: '运输计划单号',
  truckNo: '车牌号',
  driverName: '司机姓名',
  driverTel: '司机电话',
  planStatus: '预约状态',
  dealStatus: '处理状态',
  dealCount: '处理次数',
  dealTime: '处理时间',
  dealResult: '处理结果',
  originNo: '发货方编码',
  planExpToDate: '预计提货日期',
  planExpToTime: '预计提货时间',
  orderNo: '客户订单',
  createTime: '创建时间',
  detail: {
    originNo: '发货方编码',
    planExpToDate: '预计提货日期',
    planExpToTime: '预计提货时间',
  },
  msg: {}
};
export default planAppointmentLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/planAppointmentLog/lang/planAppointmentLog.zh.js